import Logo from "@/assets/icons/ic-logo-badge.svg";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Outlet, RouterProvider, createBrowserRouter } from "react-router";
import { MotionLazy } from "./components/animate/motion-lazy";
import { RouteLoadingProgress } from "./components/loading";
import Toast from "./components/toast";
import { useUser } from "./core/user/userApplication";
import { GLOBAL_CONFIG } from "./global-config";
import ErrorBoundary from "./routes/components/error-boundary";
import buildDynamicRoutes from "./routes/sections";
import { AntdAdapter } from "./theme/adapter/antd.adapter";
import { ThemeProvider } from "./theme/theme-provider";

if (import.meta.env.DEV) {
	import("react-scan").then(({ scan }) => {
		scan({
			enabled: false,
			showToolbar: true,
			log: false,
			animationSpeed: "fast",
		});
	});
}

function App() {
	const { data: user, isLoading } = useUser();
	const router = createBrowserRouter(
		[
			{
				Component: () => (
					<HelmetProvider>
						<ThemeProvider adapters={[AntdAdapter]}>
							<Helmet>
								<title>{GLOBAL_CONFIG.appName}</title>
								<link rel="icon" href={Logo} />
							</Helmet>
							<Toast />
							<RouteLoadingProgress />
							<MotionLazy>
								<Outlet />
							</MotionLazy>
						</ThemeProvider>
					</HelmetProvider>
				),
				errorElement: <ErrorBoundary />,
				children: buildDynamicRoutes(user),
			},
		],
		{
			basename: import.meta.env.BASE_URL,
		},
	);
	return isLoading ? <div>loading</div> : <RouterProvider router={router} />;
}

export default App;
